import React, { useState } from "react";
import {
  FlatList,
  View,
  StyleSheet,
  StyleProp,
  ViewStyle,
} from "react-native";
import { UserCard } from "./UserCard";
import { Indicator } from "./PageIndicator";
import _ from "lodash";
import { UsersPermissions_User } from "../api/models/UsersPermissions_User";
import { colors } from "../common/styles/colors";
import { Meeting } from "../api/models/Meeting";

export function InvitedContainer({
  invitedUsers,
  meeting,
  containerStyle,
}: {
  invitedUsers: UsersPermissions_User[];
  meeting: Meeting;
  containerStyle?: StyleProp<ViewStyle>;
}) {
  const [snapInterval, setSnapInterval] = useState(0);

  const [invitedContainerWidth, setInvitedContainerWidth] =
    useState(0);

  const [activePage, setActivePage] = useState(0);
  return (
    <View
      style={[styles.invitedContainer, containerStyle]}
      onLayout={(event) => {
        setSnapInterval(
          event.nativeEvent.layout.width - 24
        );
        setInvitedContainerWidth(
          event.nativeEvent.layout.width
        );
      }}
    >
      <FlatList
        data={_.chunk(invitedUsers, 8)}
        renderItem={({ item }) => (
          <View
            style={{
              width: invitedContainerWidth,
            }}
          >
            <View style={styles.invitedPage}>
              {item.map((_user) => (
                <View
                  style={{
                    width: "25%",
                    alignItems: "center",
                    paddingVertical: 8,
                  }}
                >
                  <UserCard
                    isAuthor={
                      meeting.author?.id === _user.id
                    }
                    user={_user}
                    voted={
                      !!meeting.votes?.find(
                        (_vote) =>
                          _vote.user?.id === _user.id
                      )
                    }
                  />
                </View>
              ))}
            </View>
          </View>
        )}
        horizontal
        onScroll={(event) => {
          setActivePage(
            Math.floor(
              Math.floor(
                event.nativeEvent.contentOffset.x +
                  snapInterval / 2
              ) / Math.floor(snapInterval)
            )
          );
        }}
        pagingEnabled={true}
        showsHorizontalScrollIndicator={false}
        snapToAlignment="start"
        decelerationRate={"fast"}
        snapToInterval={snapInterval}
        contentContainerStyle={{
          paddingTop: 20,
        }}
      />
      {invitedUsers.length > 8 && (
        <View style={styles.indicatorContainer}>
          {Array(Math.ceil(invitedUsers.length / 8))
            .fill(0)
            .map((zero, index) => (
              <Indicator
                isActive={activePage === index}
                style={
                  index === 0 && {
                    marginLeft: 0,
                  }
                }
              />
            ))}
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  invitedContainer: {
    alignSelf: "stretch",
    minHeight: 212,
    borderRadius: 16,
    backgroundColor: colors.mediumLightGray,
    borderWidth: 0.5,
    borderColor: colors.borderLightGray,
  },
  invitedPage: {
    flexWrap: "wrap",
    flexDirection: "row",
    alignContent: "center",
  },
  indicatorContainer: {
    alignSelf: "center",
    flexDirection: "row",
    marginBottom: 4,
  },
});
